import { useState } from "react"

import { Button, Text, Img } from "ui-kit/components-branded/index"
import { Call } from "modules/Call/queries"
import { CustomErrorInfo } from "components/ErrorBoundary"
import { ContactModal } from "modules/Call/components/PageError/ContactModal"
import { IS_STAGING } from "utils/env-management"

interface Props {
    fallBackData?: Call
    withModal: boolean
    error?: Error
    errorInfo?: CustomErrorInfo
}

export function PageError({ fallBackData, withModal, error, errorInfo }: Props) {
    const [active, setActive] = useState(false)

    const modal = !!(
        withModal &&
        fallBackData?.booking.psychologist.private_number &&
        fallBackData?.booking.psychologist.video_call_handle &&
        fallBackData?.booking.client.phone
    )

    const handleChangeActive = (value: boolean) => {
        setActive(value)
    }

    const openContactModal = () => {
        setActive(true)
    }

    const reloadPage = () => {
        window.location.reload()
    }

    return (
        <>
            <div className="call-page-error-contact">
                <div className="call-page-error-contact__content">
                    <div className="is-flex is-justify-content-center">
                        <Img
                            className="call-page-error-contact__illustration"
                            src="error-illustration.svg"
                        />
                    </div>
                    <div className="call-page-error-contact__title mgb-1">
                        Кажется, что-то пошло не&nbsp;так
                    </div>
                    <div className="call-page-error-contact__buttons is-flex is-justify-content-center is-align-content-center">
                        {modal && (
                            <div
                                className="call-page-error-contact__button is-contact"
                                onClick={openContactModal}
                            >
                                <Text isAccent>Связаться другим способом</Text>
                            </div>
                        )}
                        <Button
                            className="call-page-error-contact__button is-update"
                            onClick={reloadPage}
                            color="primary"
                        >
                            Обновить страницу
                        </Button>
                    </div>
                    {IS_STAGING && (
                        <div style={{ maxWidth: "100vw" }}>
                            <Text>
                                {error && (
                                    <>
                                        <pre>{error.message}</pre>
                                        <br />
                                    </>
                                )}
                                <pre>{errorInfo?.componentStack}</pre>
                            </Text>
                        </div>
                    )}
                </div>
            </div>
            {modal && (
                <ContactModal
                    active={active}
                    setActive={handleChangeActive}
                    fallBackData={fallBackData}
                />
            )}
        </>
    )
}
